import apiClient from './client';

export const servicesApi = {
  // Get service categories with stats
  getServiceCategories: async () => {
    try {
      const response = await apiClient.get('/services/categories');
      return response.data;
    } catch (error) {
      console.error('Error fetching service categories:', error);
      throw error;
    }
  },

  // Get services by category
  getServicesByCategory: async (categoryId, params = {}) => {
    try {
      const response = await apiClient.get(`/services/category/${categoryId}`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching services by category:', error);
      throw error;
    }
  },

  // Get service details
  getServiceDetails: async (serviceId) => {
    try {
      const response = await apiClient.get(`/services/service/${serviceId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching service ${serviceId}:`, error);
      throw error;
    }
  },

  // Get service statistics
  getServiceStatistics: async (period = '30d') => {
    try {
      const response = await apiClient.get('/services/statistics', { 
        params: { period } 
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching service statistics:', error);
      throw error;
    }
  },

  // Get all services with filtering
  getAllServices: async (params = {}) => {
    try {
      const response = await apiClient.get('/services/all', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching all services:', error);
      throw error;
    }
  }
};

// Legacy exports for backwards compatibility
export const getServices = servicesApi.getAllServices;
export const getServiceById = servicesApi.getServiceDetails;